/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useEffect, useState } from 'react';
import { useNavigate, Link } from 'react-router-dom';
import { Button, Tooltip, Modal, Spin, Skeleton, Empty } from 'antd';
import ResponsiveBreadcrumb from '../../components/breadcrumb/ResponsiveBreadcrumb';
import ViewAsSelector from '../../components/common/ViewAsSelector';
import * as AntDIcons from '@ant-design/icons';
import NoticeBoardSlide from '../../components/notice-board/NoticeBoardSlide';
import axios from 'axios';
import Utils from '../../misc/Utils';
import Enums from '../../misc/Enums';
import '../common/BraineeModule.css';
// import { useDispatch } from 'react-redux';
import Create from './Components/Create';
// import Edit from './Components/Edit';

export function ProjectSubjects() {
   const navigate = useNavigate();
   // const dispatch = useDispatch();

   // const user_id = Utils.getCurrentUserInfo(Enums.UserInfo.id);
   const user_role = Utils.getCurrentUserInfo(Enums.UserInfo.role);
   const user_full_name = localStorage.getItem('selected-teacher-name') ?? Utils.getCurrentUserInfo(Enums.UserInfo.fullname);

   const [user_id, setUserId] = useState(localStorage.getItem('selected-teacher') ?? Utils.getCurrentUserInfo(Enums.UserInfo.id));
   const [userList, setUserList] = useState([]);
   const [creating, setCreating] = useState(false);
   // const [updating, setUpdating] = useState(false);

   // const [homeworkID, setHomeoworkID] = useState("");
   // const [homeworkData, setHomeworkData] = useState(null);

   const [subjectList, setSubjectList] = useState([]);
   const [loading, setLoading] = useState(false);
   // const [subjectName, setSubjectName] = useState(null);
   const [createModalVisible, setCreateModalVisible] = useState(false);
   // const [editModalVisible, setEditModalVisible] = useState(false);

   useEffect(() => {
      Utils.verifyJwt();

      if (['super admin', 'admin'].includes(user_role.toLowerCase())) {
         var url = `${process.env.REACT_APP_API_LESSON}/listAllStaff`;
         axios.get(url).then((response) => {
            if (response.data) {
               let data = response.data;
               var users = data.filter((d) => d.id !== Number(user_id)).sort((a, b) => {
                  var aVal = a["first_Name"];
                  var bVal = b["first_Name"];
                  switch (typeof aVal) {
                     case 'string':
                        return aVal.localeCompare(bVal);
                     case 'number':
                        return aVal - bVal;
                     default:
                        throw new Error("Unsupported value to sort by");
                  }
               });
               var final = data.filter((d) => d.id === Number(user_id));
               Array.prototype.push.apply(final, users);
               setUserList(final)
            }
         }, (error) => {
            // setLoading(false);
            console.log(error.message);
         });
      }


      // if (user_role.toLowerCase() !== 'admin' && user_role.toLowerCase() !== 'teacher' && user_role.toLowerCase() !== 'co-teacher')
      const allowedRoles = ['super admin', 'admin', 'teacher', 'co-teacher'];
      if (!allowedRoles.includes(user_role.toLowerCase()))
         navigate('/home');

      // localStorage.removeItem('mastery-assessment-search-keys');
      getSubjects(user_id);

   }, []);

   const getSubjects = (userid) => {
      setLoading(true);
      axios.get(`${process.env.REACT_APP_API_HOMEWORK}/subjectgroup?id=${userid}&t=project`).then((response) => {
         if (response.data) {
            const data = response.data;
            var subjects = [];
            data.map((item) => {
               let obj = { 'value': item.value, 'name': item.name }
               subjects.push(obj);
            });

            setSubjectList(subjects);
         }
         setLoading(false);
      }, (error) => {
         setLoading(false);
         console.log(error.message);
      });
   }

   // function colorize() {
   //    var r = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       g = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2),
   //       b = ('0' + (Math.random() * 255 | 0).toString(16)).slice(-2);
   //    return '#' + r + g + b;
   // }

   const handleCreateProject = () => {
      setCreateModalVisible(true)
   }

   const handleCancelCreate = () => {
      setCreateModalVisible(false);
   }

   const handleOnFinishCreate = (homeworkData, fileForUpload) => {
      setCreating(true);

      if (fileForUpload.length > 0) {
         var formData = new FormData();

         fileForUpload.forEach(file => {
            // the name has to be 'files' so that .NET could properly bind it (Phuck this sheet! Took me the whole day to find this sheet!)
            formData.append('files', file);
         });

         var uploadedfiles = "";
         var url = `${process.env.REACT_APP_API_S3_UPLOAD}/uploadMultiple?s3path=${process.env.REACT_APP_S3_HOMEWORKS_TEACHERS_PATH}`;
         axios.post(url, formData).then(response => {

            if (response.data) {
               uploadedfiles = response.data;

               homeworkData.document = uploadedfiles;

               var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
               axios.post(url, homeworkData).then(response => {
                  setCreating(false);
                  if (response.data) {
                     Modal.success({
                        title: 'Project',
                        content: 'Project created.',
                        centered: true,
                        onOk: () => { setCreateModalVisible(false) },
                     });

                     getSubjects(user_id);
                  }
               }, (error) => {
                  setCreating(false);
                  Modal.error({
                     title: 'Project',
                     content: error.response.data,
                     centered: true,
                     onOk: () => { setCreateModalVisible(false) },
                  });
               });

            }
         }, (error) => {
            // console.log(error.message);
         });
      } else {
         var url = `${process.env.REACT_APP_API_HOMEWORK}/add`;
         axios.post(url, homeworkData).then(response => {
            setCreating(false);
            if (response.data) {
               Modal.success({
                  title: 'Project',
                  content: 'Project created.',
                  centered: true,
                  onOk: () => { setCreateModalVisible(false) },
               });

               getSubjects(user_id);
            }

         }, (error) => {
            setCreating(false);
            Modal.error({
               title: 'Project',
               content: error.response.data,
               centered: true,
               onOk: () => { setCreateModalVisible(false) },
            });
         });
      }
   }

   const itemSubjectClick = (subject, subjectname) => {
      navigate(`/projects?id=${subject}&name=${subjectname}&staff=${user_id}`);
   }

   const handleUserChange = (id) => {
      const teacher = userList.find((item) => item.id === id);
      if (teacher) {
         localStorage.setItem('selected-teacher-name', `${teacher.first_Name.trim()} ${teacher.last_Name.trim()}`);
      }
      localStorage.setItem('selected-teacher', id);
      setUserId(id);
      getSubjects(id);
   }

   const renderSubjectSkeletons = () => (
      <div className="brainee-module-skeleton-grid">
         {Array.from({ length: 6 }).map((_, index) => (
            <div className="brainee-module-card is-skeleton" key={`project-subject-skeleton-${index}`}>
               <Skeleton.Avatar active shape="square" className="brainee-module-card-skeleton-icon" />
               <div className="brainee-module-card-copy">
                  <Skeleton.Input active size="small" className="brainee-module-card-skeleton-title" />
                  <Skeleton.Input active size="small" className="brainee-module-card-skeleton-subtitle" />
               </div>
               <Skeleton.Button active size="small" shape="circle" className="brainee-module-card-skeleton-action" />
            </div>
         ))}
      </div>
   );

   return (
      <>
         <div className="dashboard-area-all brainee-module-page">
            <div className="dashboard-item brainee-module-shell">
               <div className="brainee-module-breadcrumb">
                  <ResponsiveBreadcrumb
                     items={[
                        { key: 'home', node: <Link to="/home">Home</Link> },
                        { key: 'lms', node: 'Brainee LMS' },
                        { key: 'ps', node: 'Project Subjects' },
                     ]}
                  />
               </div>

               <section className="brainee-module-hero">
                  <div>
                     <span className="brainee-module-kicker">Projects</span>
                     <h1>Project Subjects</h1>
                     <p>Choose a subject to manage projects, review submitted work, and keep project requirements easy to find.</p>
                     <div className="brainee-module-meta">
                        <span><AntDIcons.ProjectOutlined /> {loading ? 'Loading subjects' : `${subjectList.length} subjects`}</span>
                        <span><AntDIcons.ProfileOutlined /> Project workspace</span>
                     </div>
                  </div>
                  <div className="brainee-module-actions">
                     {['super admin', 'admin'].includes(user_role.toLowerCase()) &&
                        <ViewAsSelector
                           users={userList}
                           defaultValue={user_full_name}
                           onChange={handleUserChange}
                        />
                     }
                     <Tooltip placement="bottom" title='Create new Project'>
                        <Button className='brainee-module-create-btn' type='primary' size='large' shape='round' onClick={() => handleCreateProject()}>
                           <AntDIcons.PlusOutlined />Create Project
                        </Button>
                     </Tooltip>
                  </div>
               </section>

               <section className="brainee-module-panel">
                  <div className="brainee-module-panel-header">
                     <div>
                        <span className="brainee-module-kicker">Browse</span>
                        <h2>Subject Groups</h2>
                     </div>
                     <span className="brainee-module-count">{loading ? '...' : subjectList.length}</span>
                  </div>

                  {loading
                     ? renderSubjectSkeletons()
                     : subjectList.length > 0
                        ? <div className="brainee-module-grid">
                           {subjectList.map((subject) => (
                              <button className="brainee-module-card" key={subject.value} type="button" onClick={() => itemSubjectClick(subject.value, subject.name)}>
                                 <span className="brainee-module-card-icon"><AntDIcons.ProjectOutlined /></span>
                                 <span className="brainee-module-card-copy">
                                    <span className="brainee-module-card-title">{subject.name}</span>
                                    <span className="brainee-module-card-subtitle">Open project list</span>
                                 </span>
                                 <AntDIcons.RightOutlined className="brainee-module-card-arrow" />
                              </button>
                           ))}
                        </div>
                        : <div className='brainee-module-state'>
                           <Empty image="../images/brainee_mascot.png" description="No records found." />
                        </div>
                  }
               </section>
            </div>
         </div>

         <Modal
            title={"Create Project"}
            // className="homework-assignment-modal"
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelCreate(); }}
            open={createModalVisible}
            width={1040}
            footer={[
               <Button key="cancel" onClick={handleCancelCreate} disabled={creating}>Cancel</Button>,
               <Button key="save" type="primary" htmlType="submit" form="project-subject-create-form" loading={creating}>Save</Button>,
            ]}
         >
            <Spin spinning={creating} tip="Creating project, please wait...">
               <Create
                  formId="project-subject-create-form"
                  onCancelCallback={handleCancelCreate}
                  onFinishCallback={handleOnFinishCreate}
                  type='project'
               />
            </Spin>
         </Modal>

         {/* <Modal
            title={"Edit Project"}
            centered
            destroyOnClose={true}
            onCancel={() => { handleCancelEdit(); }}
            open={editModalVisible}
            // width={window.innerWidth - 400}
            width='80%'
            // footer={null}
            okButtonProps={{ style: { display: 'none' } }}
            cancelButtonProps={{ style: { display: 'none' } }}
         >
            <Spin spinning={updating} tip={"Processing, please wait..."}>
               <Edit
                  homeworkID={homeworkID}
                  homeworkData={homeworkData}
                  onCancelCallback={handleCancelEdit}
                  onFinishCallback={handleOnFinishEdit}
                  type='project'
               />
            </Spin>
         </Modal> */}
      </>
   )
}
